export const capitalizeFirstLetter = (str: string): string =>
  str && str.charAt(0).toUpperCase() + str.slice(1)

export const capitalize = (string: string) =>
  string ? `${string.split('')[0].toUpperCase()}${string.substring(1)}` : ''

export const snakeCaseTransform = (string: string) =>
  string ? string.replace('_', ' ') : ''
